<template>
  <div class="comment-editor-box">
    <FormGroup :form="commentForm">
      <FormUploadDropTarget @filesDropped="$refs.documentUpload.filesDroppedFromTarget($event)">
        <FormInputTextArea ref="commentMessage" :rows="2" placeholder="Type your comment" class="post-comment-text-area" v-model="commentData.message" @input="dataChanged" />
        <div class="row no-gutters post-comment-text-area mt-2">
          <div class="col-2">
            <FormButton class="btn-sm btn-primary mr-2" @click="onPostClicked" :loading="submitting">Post</FormButton>
            <button type="button" class="btn btn-white btn-sm" @click.prevent="onCancelClicked">Cancel</button>
          </div>
          <div class="col-5">
            <span class="float-left col-form-label mx-2">Attachments: </span>
            <FormUpload ref="documentUpload" v-model="commentData.fileList" />
          </div>
          <div class="col-5">
            <span class="float-left col-form-label mx-2">Labels: </span>
            <FormLabelTag v-model="commentData.labelList" @input="dataChanged" labelType="comment" field="labelList" />
          </div>
        </div>
      </FormUploadDropTarget>
    </FormGroup>
  </div>
</template>

<style scoped>
.comment-editor-box {
  background-color: #fdfdfd;
  border: 1px solid #e7eaec;
  padding: 8px;
  margin: 4px;
}
</style>

<script>
import _ from 'lodash'
import form from '@/mixins/form'

export default {
  name: 'ActivityCommentEditor',
  mixins: [form],
  model: {
    event: 'update'
  },
  props: {
    value: Object,
    linkType: String,
    linkId: [String, Number],
    parentActivityItemId: Number
  },
  watch: {
    value: function(newVal, oldVal) {
      this.$data.commentData.message = newVal.message ? newVal.message : ''
      this.$data.commentData.labelList = newVal.labelList ? _.clone(newVal.labelList) : []
      this.$data.commentData.fileList = newVal.fileList ? _.clone(newVal.fileList) : []
    }
  },
  data() {
    return {
      commentData: {
        message: '',
        fileList: [],
        labelList: [],
      },
      submitting: false,
      commentForm: {}
    }
  },
  methods: {
    select() {
      this.$refs.commentMessage.focus()
      this.$refs.commentMessage.select()
    },
    onPostClicked(evt) {
      if(!this.$refs.documentUpload.validateUploadsComplete())
        return
        
      this.submitting = true
      this.commentForm = this.clearFormResponse()

      var commentData = {
        linkType: this.linkType,
        linkId: parseInt(this.linkId ? this.linkId : 0),
        message: this.commentData.message,
        labelList: this.commentData.labelList.map(label => label.id),
        uploadFileList: this.commentData.fileList
      }
      if(this.parentActivityItemId == null) {
        this.$apiService.coreService.createComment(commentData)
        .then(response => {
          this.$emit('post')
        })
        .catch(err => {
          this.commentForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
      } else {
        this.$apiService.coreService.createReplyComment(this.parentActivityItemId, commentData)
        .then(response => {
          this.$emit('post')
        })
        .catch(err => {
          this.commentForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })

      }
    },
    onCancelClicked(evt) {
      this.$emit('cancel', evt)
    },
    dataChanged() {
      this.$emit('update', this.commentData)
    }
  }
}
</script>